const lazyImages = document.querySelectorAll('[data-lazy]');

if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                observer.unobserve(img);
            }
        });
    });

    lazyImages.forEach(img => {
        observer.observe(img);
    });
} else {
    lazyImages.forEach(img => {
        img.src = img.dataset.src;
    });
}
